export default (node) => {
  /**
   * Data + elements
   */
  const buttonModal = node.querySelector('[data-open-modal]');
  /**
   * Functions
   */

  /**
   * Init
   */
  const init = () => {
    if (buttonModal) {
      buttonModal.addEventListener('click', (e) => {
        e.preventDefault();
        const event = new CustomEvent('modal-video:open', {
          detail: node.querySelector('[data-media-container] > div'),
        });
        document.dispatchEvent(event);
      });
    }
  };

  init();
};
